import { render, staticRenderFns } from "./AI_Widgets.vue?vue&type=template&id=34b48a2c&scoped=true&"
import script from "./AI_Widgets.vue?vue&type=script&lang=js&"
export * from "./AI_Widgets.vue?vue&type=script&lang=js&"
import style0 from "./AI_Widgets.vue?vue&type=style&index=0&id=34b48a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b48a2c",
  null
  
)

export default component.exports